<script>
import Repositories from '@/repositories';
const ItemsRepository = Repositories.get('items');
const WorkOrderItemsRepository = Repositories.get('workorderitems');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Multiselect from 'vue-multiselect';
import statusMixin from '@/mixins/statusMixin';
import GridComponent from '@/components/widgets/grids/pagination-grid';
import dateMixin from '@/mixins/dateMixin';
/**
 * Dashboard Component
 */
export default {
  props: {
    selectedWorkOrderItems: Array,
    selectedItems: Array,
  },
  components: {
    Loading,
    Multiselect,
    GridComponent,
  },
  mixins: [statusMixin, dateMixin],
  data() {
    return {
      isLoading: false,
      selectedSupplier: [],
      selectedCategories: [],
      itemsList: [],
      workOrderItemsList: [],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;

      let promise1 = ItemsRepository.getAll().then((response) => {
        this.itemsList = response.data.data;
      });

      let promise2 = WorkOrderItemsRepository.customREST
        .getRequested()
        .then((response) => {
          this.workOrderItemsList = response.data;
        });

      Promise.all([promise1, promise2])
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        });
    },
    addWorkOrderItem(workOrderItem) {
      this.$emit('add-work-order-item', workOrderItem);
    },
    addItem(item) {
      this.$emit('add-item', item);
    },
  },
  computed: {
    suppliers() {
      return this.$store.state.cache.suppliers;
    },
    categories() {
      return this.$store.state.cache.categories;
    },
    selectedSupplierIds() {
      return this.selectedSupplier.map((a) => a.idPublic);
    },
    selectedCategoriesIds() {
      return this.selectedCategories.map((a) => a.idPublic);
    },
    itemsListFiltered() {
      if (this.itemsList == null) {
        return [];
      }

      return this.itemsList
        .map((x) => {
          let status = this.getStatusFromCode(x.status, 'Inventory');
          let availableQuantity = this.toFloat(
            x.totalQuantity - x.reservedQuantity
          );
          return { ...x, ...status, availableQuantity };
        })
        .filter((row) => {
          let isRightFilter = true;

          if (
            row.supplierIdPublic == null &&
            this.selectedSupplierIds.includes(0)
          ) {
            isRightFilter = true;
          } else if (
            this.selectedSupplierIds.length > 0 &&
            !this.selectedSupplierIds.includes(row.supplierIdPublic)
          ) {
            isRightFilter = false;
          }

          if (
            row.categoryIdPublic == null &&
            this.selectedCategoriesIds.includes(0)
          ) {
            isRightFilter = true;
          } else if (
            this.selectedCategoriesIds.length > 0 &&
            !this.selectedCategoriesIds.includes(row.categoryIdPublic)
          ) {
            isRightFilter = false;
          }

          if (this.selectedItems.includes(row.idPublic)) {
            isRightFilter = false;
          }

          return isRightFilter;
        });
    },
    workOrderItemsListFiltered() {
      return this.workOrderItemsList.filter((row) => {
        let isRightFilter = true;

        if (
          row.supplierIdPublic == null &&
          this.selectedSupplierIds.includes(0)
        ) {
          isRightFilter = true;
        } else if (
          this.selectedSupplierIds.length > 0 &&
          !this.selectedSupplierIds.includes(row.supplierIdPublic)
        ) {
          isRightFilter = false;
        }

        if (
          row.categoryIdPublic == null &&
          this.selectedCategoriesIds.includes(0)
        ) {
          isRightFilter = true;
        } else if (
          this.selectedCategoriesIds.length > 0 &&
          !this.selectedCategoriesIds.includes(row.categoryIdPublic)
        ) {
          isRightFilter = false;
        }

        if (this.selectedWorkOrderItems.includes(row.idPublic)) {
          isRightFilter = false;
        }

        return isRightFilter;
      });
    },
    criticalItems() {
      return this.itemsListFiltered.filter(
        (item) => item.totalQuantity + item.orderedQuantity < item.minQuantity
      );
    },
    requestedItems() {
      return this.itemsListFiltered.filter(
        (item) => item.orderRequestQuantity > 0
      );
    },
    workOrdersRequestsFields() {
      return [
        {
          key: 'itemName',
          label: this.$t('items.itemName'),
          sortable: true,
        },
        {
          key: 'categoryName',
          label: this.$t('categories.categoryName'),
          sortable: true,
        },
        {
          key: 'workOrderName',
          label: this.$t('workOrders.workOrderName'),
          sortable: true,
        },
        {
          key: 'supplierName',
          label: this.$t('suppliers.supplierName'),
          sortable: true,
        },
        {
          key: 'workOrderDeliveryDate',
          label: this.$t('general.deliveryDate'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'requestedQuantity',
          label: this.$t('items.requestedQuantity'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'supplierIdPublic',
          label: this.$t('general.add'),
          class: 'centered-field max-100',
          tdClass: 'max-100',
        },
      ];
    },
    requestedItemsFields() {
      return [
        {
          key: 'name',
          label: this.$t('items.itemName'),
          sortable: true,
        },
        {
          key: 'categoryName',
          label: this.$t('categories.categoryName'),
          sortable: true,
        },
        {
          key: 'supplierName',
          label: this.$t('suppliers.supplierName'),
          sortable: true,
        },
        {
          key: 'orderRequestQuantity',
          label: this.$t('items.requestedQuantity'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'supplierIdPublic',
          label: this.$t('general.add'),
          class: 'centered-field max-100',
          tdClass: 'max-100',
        },
      ];
    },
    criticalItemsFields() {
      return [
        {
          key: 'name',
          label: this.$t('items.itemName'),
          sortable: true,
        },
        {
          key: 'categoryName',
          label: this.$t('categories.categoryName'),
          sortable: true,
        },
        {
          key: 'supplierName',
          label: this.$t('suppliers.supplierName'),
          sortable: true,
        },
        {
          key: 'missingQuantity',
          label: this.$t('items.missingQuantity'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'supplierIdPublic',
          label: this.$t('general.add'),
          class: 'centered-field max-100',
          tdClass: 'max-100',
        },
      ];
    },
  },
};
</script>

<template>
  <b-container fluid>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <b-row>
      <b-col cols="4">
        <b-form-group
          id="supplier_selection"
          :label="$t('suppliers.suppliers')"
          label-for="supplierSelect"
        >
          <multiselect
            id="supplierSelect"
            ref="multiselectSupplier"
            v-model="selectedSupplier"
            :options="suppliers"
            :label="'name'"
            track-by="idPublic"
            :placeholder="$t('general.pickAValue')"
            @remove="multiselectClosed($refs.multiselectSupplier)"
            :multiple="true"
            :show-labels="false"
            :hide-selected="true"
            :close-on-select="false"
            :clear-on-select="false"
            :searchable="false"
          >
            <template v-slot:noOptions>
              {{ $t('general.noResult') }}
            </template>
            <template slot="tag" slot-scope="{ option, remove }">
              <span
                class="custom__tag badge badge-primary badge-pill"
                style="font-size: 1em; margin-right: 5px; cursor: pointer"
                v-html="option.name"
                @click="remove(option)"
              >
              </span>
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group
          id="categories_selection"
          :label="$t('categories.category')"
          label-for="categoriesSelect"
        >
          <multiselect
            id="categoriesSelect"
            ref="multiselectCategories"
            v-model="selectedCategories"
            :options="categories"
            :label="'name'"
            track-by="idPublic"
            :placeholder="$t('general.pickAValue')"
            @remove="multiselectClosed($refs.multiselectCategories)"
            :multiple="true"
            :show-labels="false"
            :hide-selected="true"
            :close-on-select="false"
            :clear-on-select="false"
            :searchable="false"
          >
            <template v-slot:noOptions>
              {{ $t('general.noResult') }}
            </template>
            <template slot="tag" slot-scope="{ option, remove }">
              <span
                class="custom__tag badge badge-primary badge-pill"
                style="font-size: 1em; margin-right: 5px; cursor: pointer"
                v-html="option.name"
                @click="remove(option)"
              >
              </span>
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
    </b-row>

    <b-tabs content-class="mt-3" fill>
      <b-tab active>
        <template #title>
          {{ $t('shoppingCart.workOrdersRequests') }}
          <span
            v-if="workOrderItemsListFiltered.length > 0"
            class="badge badge-danger pt-1 pb-1"
            style="margin-left: 5px; font-size: 0.8em; min-width: 20px"
          >
            {{ workOrderItemsListFiltered.length }}
          </span>
        </template>
        <GridComponent
          v-if="workOrderItemsListFiltered.length > 0"
          id="work-orders-requests-grid"
          :fields="workOrdersRequestsFields"
          :items="workOrderItemsListFiltered"
          :per-page="5"
          head-variant="none"
          :no-top-border="true"
        >
          <template #cell(workOrderDeliveryDate)="data">
            {{ formatDate(data.item.workOrderDeliveryDate) }}
          </template>

          <template #cell(supplierIdPublic)="data">
            <div v-if="data.item.supplierIdPublic != null">
              <i
                class="fas fa-plus text-success pl-2 pr-2"
                @click="addWorkOrderItem(data.item)"
                style="cursor: pointer; font-size: 1.4em"
              ></i>
            </div>
            <div
              v-else
              :id="'popover-work-orders-requests-' + data.item.idPublic"
            >
              <i
                class="fas fa-exclamation-circle text-warning pl-2 pr-2"
                style="font-size: 1.4em"
              ></i>

              <b-popover
                :target="'popover-work-orders-requests-' + data.item.idPublic"
                triggers="hover"
                placement="left"
                variant="warning"
              >
                <div style="font-size: 1.2em">
                  <span
                    v-html="
                      $t('warnings.noDefaultSupplier').replace(
                        '$',
                        data.item.itemName
                      )
                    "
                  ></span>
                </div>
              </b-popover>
            </div>
          </template>
        </GridComponent>
        <div v-else>
          <h3 class="text-center">{{ $t('items.noMoreItems') }}</h3>
        </div>
      </b-tab>
      <b-tab>
        <template #title>
          {{ $t('shoppingCart.inventoryRequests') }}
          <span
            v-if="requestedItems.length > 0"
            class="badge badge-danger pt-1 pb-1"
            style="margin-left: 5px; font-size: 0.8em; min-width: 20px"
            >{{ requestedItems.length }}
          </span>
        </template>
        <GridComponent
          v-if="requestedItems.length > 0"
          id="requested-items-grid"
          head-variant="none"
          :fields="requestedItemsFields"
          :items="requestedItems"
          :per-page="5"
          :no-top-border="true"
        >
          <template #cell(supplierIdPublic)="data">
            <div v-if="data.item.supplierIdPublic != null">
              <i
                class="fas fa-plus text-success pl-2 pr-2"
                @click="addItem(data.item, 'requested')"
                style="cursor: pointer; font-size: 1.4em"
              ></i>
            </div>
            <div v-else :id="'popover-requested-items-' + data.item.idPublic">
              <i
                class="fas fa-exclamation-circle text-warning pl-2 pr-2"
                style="font-size: 1.4em"
              ></i>

              <b-popover
                :target="'popover-requested-items-' + data.item.idPublic"
                triggers="hover"
                placement="left"
                variant="warning"
              >
                <div style="font-size: 1.2em">
                  <span
                    v-html="
                      $t('warnings.noDefaultSupplier').replace(
                        '$',
                        data.item.name
                      )
                    "
                  ></span>
                </div>
              </b-popover>
            </div>
          </template>
        </GridComponent>
        <div v-else>
          <h3 class="text-center">{{ $t('items.noMoreItems') }}</h3>
        </div>
      </b-tab>
      <b-tab>
        <template #title>
          {{ $t('shoppingCart.criticalItems') }}
          <span
            v-if="criticalItems.length > 0"
            class="badge badge-danger pt-1 pb-1"
            style="margin-left: 5px; font-size: 0.8em; min-width: 20px"
            >{{ criticalItems.length }}
          </span>
        </template>
        <GridComponent
          v-if="criticalItems.length > 0"
          id="critical-items-grid"
          head-variant="none"
          :fields="criticalItemsFields"
          :items="criticalItems"
          :per-page="5"
          :no-top-border="true"
        >
          <template #cell(missingQuantity)="data">
            {{
              data.item.minQuantity -
              (data.item.totalQuantity -
                data.item.reservedQuantity +
                data.item.orderedQuantity)
            }}
          </template>

          <template #cell(supplierIdPublic)="data">
            <div v-if="data.item.supplierIdPublic != null">
              <i
                class="fas fa-plus text-success pl-2 pr-2"
                @click="addItem(data.item, 'critical')"
                style="cursor: pointer; font-size: 1.4em"
              ></i>
            </div>
            <div v-else :id="'popover-critical-items-' + data.item.idPublic">
              <i
                class="fas fa-exclamation-circle text-warning pl-2 pr-2"
                style="font-size: 1.4em"
              ></i>

              <b-popover
                :target="'popover-critical-items-' + data.item.idPublic"
                triggers="hover"
                placement="left"
                variant="warning"
              >
                <div style="font-size: 1.2em">
                  <span
                    v-html="
                      $t('warnings.noDefaultSupplier').replace(
                        '$',
                        data.item.name
                      )
                    "
                  ></span>
                </div>
              </b-popover>
            </div>
          </template>
        </GridComponent>
        <div v-else>
          <h3 class="text-center">{{ $t('items.noMoreItems') }}</h3>
        </div>
      </b-tab>
    </b-tabs>
  </b-container>
</template>